import React, { useEffect, useState } from "react";

import { Instant, nativeJs } from "@js-joda/core";
import { IInstantProps } from "components/dashboard/product-template-table/utils/interfaces";
import { formatDataPatternToCalendar } from "components/dashboard/product-template-table/utils/utils";
import { Calendar } from "primereact/calendar";
import { FormEvent } from "primereact/ts-helpers";
import { DATE_PATTERN_MINUTES } from "utils/constants";
import { useDisplayTimezone } from "hooks/useTimezone";
import { formatDisplayDatetime } from "utils/time-utils";

const InstantComponent = (props: IInstantProps) => {
    const displayTz = useDisplayTimezone();
    const [instant, setInstant] = useState<Instant | undefined>(props.value ? Instant.parse(props.value) : undefined);
    const [onCalendarFocus, setOnCalendarFocus] = useState<boolean | undefined>(undefined);

    useEffect(() => {
        if (onCalendarFocus === false && instant !== undefined) {
            props.changeHandler( instant.toString())
        }
    }, [onCalendarFocus]);

    const dateChangeHandler = (e: FormEvent<Date, React.SyntheticEvent<Element, Event>>) => {
        const date = e.value as Date;
        if (date) {
            setInstant(Instant.from(nativeJs(date)));
            props.changeHandler(date.toISOString())
        }
    }

    const hasHours = () => {
        let has = true;
        if (props.format) {
            has = props.format.split(' ')[1] !== undefined;
        }
        return has;
    }
    const dateFormat = formatDataPatternToCalendar(props.format ?? DATE_PATTERN_MINUTES)?.split(" ")[0]
    
    if (props.isInEditMode) {
        return <Calendar hourFormat="24"
                         className="w-full"
                         value={instant ? new Date(instant.toEpochMilli()) : undefined}
                         onChange={dateChangeHandler}
                         onFocus={() => setOnCalendarFocus(true)}
                         onHide={() => setOnCalendarFocus(false)}
                         dateFormat={dateFormat}
                         onInput={e => {
                             const val = e.target as HTMLInputElement;
                             if (!val.value) {
                                 setInstant(undefined);
                                 props.changeHandler(undefined)
                             }
                         }}
                         showTime={hasHours()}
        />
    } 
        return <div>
            {formatDisplayDatetime(instant, displayTz, props.format)}
        </div>;
    
};

export default InstantComponent;